import {
  Configuration,
  CompanyRegistrationApi,
} from '@openapi/company-registration-form';

export const companyRegistrationApi = new CompanyRegistrationApi(
  new Configuration({
    basePath: '/api/company_registration.php',
    credentials: 'same-origin',
  }),
);
